var _excluded = ["isReadOnly", "isDisabled", "isLoading", "placeholder", "value", "displayValue", "onSelect", "defaultIsOpen", "weekDays", "excludeHolidays", "secondarySelectedDate", "minDate", "maxDate", "showToday", "backButton", "legendItems", "format"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import { formatDateTime } from '@melio/penny-utils';
import { noop } from 'lodash';
import { useState } from 'react';
import { Group } from '../../../containers';
import { Icon } from '../../../foundations/Icon';
import { forwardRef } from '../../../utils';
import { Text } from '../../dataDisplay';
import { DatePicker } from '../../selectionAndInputs/DatePicker';
import { _TableCell as TableCell } from '../_TableCell';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

/**
 * @private Please use `Table.DateCell` from `@melio/penny`.
 */
export var _TableDateCell = forwardRef((_ref, ref) => {
  var _ref2;

  var {
    isReadOnly,
    isDisabled,
    isLoading,
    placeholder,
    value,
    displayValue,
    onSelect,
    defaultIsOpen,
    weekDays,
    excludeHolidays,
    secondarySelectedDate,
    minDate,
    maxDate,
    showToday,
    backButton,
    legendItems,
    format
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  var isEnabled = !isDisabled && !isReadOnly && !isLoading;
  var [isMenuOpen, setIsMenuOpen] = useState((_ref2 = defaultIsOpen && isEnabled) !== null && _ref2 !== void 0 ? _ref2 : false);
  var formattedDate = formatDateTime(value, {
    format
  });
  var labelColor = value ? isDisabled ? 'neutral.light' : isReadOnly ? 'neutral.black' : 'neutral.black' : 'neutral.darker';
  var displayValueContent = typeof displayValue === 'string' ? /*#__PURE__*/_jsx(Text, {
    textStyle: "inline",
    color: labelColor,
    shouldSupportEllipsis: true,
    children: displayValue
  }) : displayValue;

  var valueContent = /*#__PURE__*/_jsx(Text, {
    textStyle: "inline",
    color: labelColor,
    shouldSupportEllipsis: true,
    children: value ? formattedDate : placeholder
  });

  var selectCell =
  /*#__PURE__*/
  // TODO: remove empty onClick. It must be passed in order for the hover background color to show.
  // ticket - ME-452 - https://meliorisk.atlassian.net/browse/ME-452
  _jsx(TableCell, _objectSpread(_objectSpread({
    "data-component": "_TableDateCell",
    "data-testid": "table-date-cell",
    onClick: isReadOnly || isDisabled ? undefined : noop,
    ref: ref
  }, props), {}, {
    children: /*#__PURE__*/_jsx(Group, {
      width: "full",
      alignItems: "center",
      justifyContent: "space-between",
      spacing: "m",
      children: /*#__PURE__*/_jsxs(_Fragment, {
        children: [displayValueContent !== null && displayValueContent !== void 0 ? displayValueContent : valueContent, !isReadOnly && !isDisabled && !isLoading && /*#__PURE__*/_jsx(Icon, {
          type: isMenuOpen ? 'caret-up' : 'caret-down',
          size: "small",
          color: "default",
          "aria-hidden": true
        })]
      })
    })
  }));

  var datePickerTestId = "".concat(props['data-testid'] || 'table-date-cell', "-dropdown-date-picker");
  return /*#__PURE__*/_jsx(DatePicker, {
    trigger: selectCell,
    isOpen: isMenuOpen,
    onOpenChange: setIsMenuOpen,
    isReadOnly: isReadOnly,
    isDisabled: isDisabled,
    onSelect: onSelect,
    value: value,
    weekDays: weekDays,
    excludeHolidays: excludeHolidays,
    secondarySelectedDate: secondarySelectedDate,
    minDate: minDate,
    maxDate: maxDate,
    showToday: showToday,
    backButton: backButton,
    legendItems: legendItems,
    "data-testid": datePickerTestId
  });
});
_TableDateCell.displayName = '_TableDateCell';
//# sourceMappingURL=_TableDateCell.js.map